import { api, getAuthHeader } from './help';

export const createUploadSession = async () => {
  const response = await api.post('/claim/upload/session', null, getAuthHeader());
  return response.data;
};

export const stageDocument = async ({ file, uploadSessionId, category, onUploadProgress }) => {
  const formData = new FormData();
  const filename = file.path || file.name;
  formData.append('file', file, filename);
  formData.append('uploadSessionId', uploadSessionId);
  formData.append('category', category);

  const auth = getAuthHeader();
  const response = await api.post('/claim/upload/stage', formData, {
    ...auth,
    headers: {
      ...auth.headers,
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
  return response.data;
};

export const deleteStagedDocument = async (documentId, uploadSessionId) => {
  const response = await api.delete(`/claim/upload/${documentId}`, {
    ...getAuthHeader(),
    params: { uploadSessionId },
  });
  return response.data;
};

export const listSessionDocuments = async (uploadSessionId) => {
  const response = await api.get(`/claim/upload/session/${uploadSessionId}`, getAuthHeader());
  return response.data;
};

export const createClaimStaged = async ({ claimData, uploadSessionId }) => {
  const response = await api.post(
    '/claim/create/staged',
    { claimData, uploadSessionId },
    getAuthHeader(),
  );
  return response.data;
};

export const getClaimSubmissionStatus = async (uploadSessionId) => {
  const response = await api.get(`/claim/submission/${uploadSessionId}/status`, getAuthHeader());
  return response.data;
};

export const getClaimDocumentStatus = async (claimId) => {
  const response = await api.get(`/claim/submission/doc/${claimId}/status`, getAuthHeader());
  return response.data;
};
